export const MODES = {
  desktop: 'desktop',
  tablet: 'tablet',
  mobile: 'mobile',
};
